import React, { useState, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { PrimaryButton } from 'office-ui-fabric-react';
import TextButton from '../../components/TextButton';
import Module from '../../components/Module';
import ModuleContent from '../../components/ModuleContent';
import ProductForm from '../../components/ProductForm';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import SavingIndicator from '../../components/SavingIndicator';
import styles from './EditProduct.style';

const EditProduct = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const ref = useRef();
  const { tokenId } = useParams();

  const handleCancel = () => {
    history.push(`/products/${tokenId}`);
  };

  const handleSave = async () => {
    setIsSubmitting(true);

    if (ref.current.dirty) {
      await ref.current.submitForm();
      if (ref.current && !isEmpty(ref.current.errors)) {
        setIsSubmitting(false);
      }
    } else {
      const invalidFields = await ref.current.validateForm();
      if (isEmpty(invalidFields)) {
        history.push(`/products/${tokenId}`);
      } else {
        setIsSubmitting(false);
      }
    }
  };

  const handleSuccess = product => {
    history.push(`/products/${product.tokenId}`);
  };

  return (
    <>
      <PageTitle>Edit Product Details</PageTitle>

      <Main>
        <Module>
          <ModuleContent>
            <ProductForm tokenId={tokenId} ref={ref} onSuccess={handleSuccess} />
          </ModuleContent>
        </Module>

        <div className={styles.buttonContainer} data-testid="buttonContainer">
          <TextButton
            className={styles.cancelButton}
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </TextButton>
          {!isSubmitting ? (
            <PrimaryButton type="submit" onClick={handleSave} disabled={isSubmitting}>
              Save and Continue
            </PrimaryButton>
          ) : (
            <SavingIndicator />
          )}
        </div>
      </Main>
    </>
  );
};

EditProduct.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      tokenId: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default EditProduct;
